import "./Guide.css";
import { useNavigate } from "react-router-dom";
import { InfoModal } from "./InfoModal";
import { IoIosCloseCircleOutline, IoMdArrowRoundBack, IoMdInformationCircleOutline } from "react-icons/io";
import { themeColours } from "../../resources";
const feedback = require("../../assets/guideArt.png");
export function Guide() {
  const navigate = useNavigate();
  function handleStartGuide() {
    localStorage.setItem("isGuide", "T");
    return navigate("home");
  }
  return (
    <div className="pageContainer">
      <div className="guidePage">
        <img src={feedback} className="guideImage" alt="guide"></img>
        <div className="guideHeader">
          <h4>Welcome to Pick and Price</h4>
          <h6>
            We are designed to help you find the <strong className="extraBold">best value</strong> for{" "}
            <strong className="extraBold">everyday items</strong>, whether you split your shop across stores or not.
            Through consolidation of prices across <strong className="extraBold">various stores</strong>, our goal is to
            help you find the best value for a <strong className="extraBold">specific item</strong>, or across{" "}
            <strong className="extraBold">brands</strong>, and even across{" "}
            <strong className="extraBold">similar items</strong> - an industry first!
          </h6>
        </div>
        <span className="guideButtonSpan">
          <InfoModal
            element={<button className={`primaryButton guideButton`}>Take a tour</button>}
            heading={"Just a heads up"}
            texts={[
              <h5 className="modalInfo">
                Keep a lookout for the{" "}
                <IoMdInformationCircleOutline
                  size={20}
                  color={themeColours.green}
                  style={{ display: "inline", verticalAlign: "middle" }}
                />{" "}
                symbols to gather further information and progress through the tour. Use
                <IoMdArrowRoundBack
                  size={20}
                  color={themeColours.primary}
                  style={{ display: "inline", verticalAlign: "middle" }}
                />{" "}
                to navigate back, and{" "}
                <IoIosCloseCircleOutline
                  size={20}
                  color={themeColours.red}
                  style={{ display: "inline", verticalAlign: "middle" }}
                />{" "}
                to exit the guide.
              </h5>,
            ]}
            buttonText="Begin"
            onButtonClick={handleStartGuide}
            modalClassName="guideModalOverlay modalInfo"
          />
        </span>
      </div>
    </div>
  );
}
